import { useQuery } from "react-query";
import { apiEmpleo } from "../../util/ApiEmpleo";

export default function useServiceQuery(serviceId: string) {
  return useQuery(
    ["service", serviceId],
    async () => {
      const params = {};

      let res = await apiEmpleo.get(`services/${serviceId}`, { params });

      return res;
    },
    {
      enabled: true,
      cacheTime: 1000 * 60 * 5,
    }
  );
}
